var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"slide-out-container"}},[_c('div',{staticClass:"overlay",style:(`--vr-height:${_vm.height}`)},[_c('div',{staticClass:"slide-out",class:{ ['is-mounted']: _vm.isMounted }},[_c('div',{staticClass:"slide-out__header"}),_c('div',{staticClass:"slide-out__body"},[_vm._t("default",null,{"onClose":_vm.onClose})],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }